<template>
  <div>
    <table class="achievements mt-3">
      <thead>
      <tr>
        <th scope="col">Session</th>
        <th scope="col">Sr.No</th>
        <th scope="col">Activity</th>
        <th scope="col">Tentative Schedule</th>
      </tr>
      </thead>
      <tbody>
      <tr class="text-justify" v-for="(activity,index) in activities"
          :key="index">
        <td class="text-gray-800 font-medium" v-html="activity.month"></td>
        <td>{{ activity.sr }}</td>
        <td>{{ activity.activity }}</td>
        <td>{{ activity.tentative }}</td>
      </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: "ActivityPlans",
  props: {
    activities: Object,
    sessions: Array
  }
}
</script>

<style scoped>

</style>